import React from "react";

interface ImageProps {
  path?: string;
  src?: string;
  alt?: string;
  style?: any;
}
interface ImageState {
  imgLoaded: boolean;
  src: string;
}
const cdn = process.env.PSYSUP_CDN;

// tslint:disable:max-line-length
class ImageComponent extends React.Component<ImageProps, ImageState> {
  observer: IntersectionObserver;

  constructor(props: ImageProps) {
    super(props);
    this.state = {
      imgLoaded: false,
      src: "",
    };
    this.handleImageErrored = this.handleImageErrored.bind(this);
    this.handleImageLoaded = this.handleImageLoaded.bind(this);
  }

  public handleImageLoaded() {
    this.setState({ imgLoaded: true });
  }

  public handleImageErrored() {
    this.setState({ imgLoaded: false });
  }

  public componentDidMount() {
    /*
        if ("IntersectionObserver" in window && this.props.lazy !== false) {
            const options = {
              rootMargin: "100px",
              threshold: .1,
            };
            const imgObserver = (entries: any) => {
                if (entries[0].isIntersecting) {
                    this.setState({
                        imgLoaded: true,
                        src: this.props.path ? cdn + this.props.path : this.props.src,
                    });
                }
            };
            this.observer = new IntersectionObserver(imgObserver, options);
            this.observer.observe(ReactDOM.findDOMNode(this) as Element);
          } else {
              */
    // cant do lazy loading images
    this.setState({
      src: this.props.path ? cdn + this.props.path : this.props.src,
    });
  }

  public componentWillUnmount() {
    if (this.observer && typeof this.observer.disconnect === "function") {
      this.observer.disconnect();
    }
  }

  public render() {
    return (
      <div
        className={`smooth-image-wrapper img-${this.state.imgLoaded === true ? "visible" : ""}`}
        style={this.props.style ? this.props.style : null}
      >
        <img
          src={this.state.src}
          className={`img-fluid img-${this.state.imgLoaded === true ? "visible" : "hidden"}`}
          onLoad={this.handleImageLoaded}
          onError={this.handleImageErrored}
          alt={this.props.alt}
          style={this.props.style ? this.props.style : null}
          loading="lazy"
        />

        <div className={`smooth-preloader img-${this.state.imgLoaded === true ? "hidden" : "visible"}`}>
          <span className={`${this.state.imgLoaded === true ? "" : "loader"}`} />
        </div>
      </div>
    );
  }
}

export default ImageComponent;
